/* eslint-disable camelcase */
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Typography, CircularProgress } from '@mui/material';
import * as VendorEventActions from '../../../../../core/vendor-events/action';
import { TranslucentContainer } from '../../../../../components';
import EventSection from './EventSection';
import { GROUP_USER } from '../../../../../config/appGroupConfig';

export default function UpcomingEvents() {
  const dispatch = useDispatch();
  const { eventList, loading } = useSelector((store) => store.vendorEvents);
  const { user } = useSelector((store) => store.users);
  const [showComponent, setShowComponent] = useState(false);
  useEffect(() => {
    if (user?.id) {
      dispatch(VendorEventActions.getVendorEvents(user.id));
      if (user.role.name === GROUP_USER.VENDOR) setShowComponent(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.id, dispatch]);
  if (!showComponent) return null;
  const currentDate = new Date();
  const formattedDate = currentDate.toISOString();
  const pastEvents = eventList?.filter((_event) => {
    const eventDate = _event.event.parameters_event?.event_date
      ? new Date(_event.event.parameters_event.event_date)
      : null;
    console.log('formattedDate:', formattedDate);
    return eventDate && eventDate < currentDate;
  });
  const upcomingEvents = eventList?.filter((_event) => {
    const eventDate = _event.event.parameters_event?.event_date
      ? new Date(_event.event.parameters_event.event_date)
      : null;
    console.log('formattedDate:', formattedDate);
    return eventDate && eventDate >= currentDate;
  });
  return (
    <>
      <Grid container justifyContent="center" textAlign="center" sx={{ mb: 3 }}>
        <TranslucentContainer>
          <Typography
            component="div"
            variant="h5"
            color="#0997BA"
            textAlign="left"
            marginLeft="1rem"
            m={2}>
            Past events
          </Typography>
          <div
            style={{
              overflowY: 'scroll',
              minHeight: '10rem',
              maxHeight: '30rem',
              scrollBehavior: 'smooth',
              margin: '1rem',
            }}>
            {loading ? (
              <CircularProgress />
            ) : (
              <div>
                {pastEvents?.length ? (
                  pastEvents.map(({ event }) => <EventSection key={event?.id} event={event} />)
                ) : (
                  <>
                    <p>There are no paid events to display.</p>
                    <p>
                      If you are approved for an event, please make sure you complete your payment.
                    </p>
                  </>
                )}
              </div>
            )}
          </div>
        </TranslucentContainer>
      </Grid>
      <Grid container justifyContent="center" textAlign="center" sx={{ mb: 3 }}>
        <TranslucentContainer>
          <Typography
            component="div"
            variant="h5"
            color="#0997BA"
            textAlign="left"
            marginLeft="1rem"
            m={2}>
            Upcoming events
          </Typography>
          <div
            style={{
              overflowY: 'scroll',
              minHeight: '10rem',
              maxHeight: '30rem',
              scrollBehavior: 'smooth',
              margin: '1rem',
            }}>
            {loading ? (
              <CircularProgress />
            ) : (
              <div>
                {upcomingEvents?.length ? (
                  upcomingEvents.map(({ event }) => <EventSection key={event?.id} event={event} />)
                ) : (
                  <>
                    <p>There are no paid events to display.</p>
                    <p>
                      If you are approved for an event, please make sure you complete your payment.
                    </p>
                  </>
                )}
              </div>
            )}
          </div>
        </TranslucentContainer>
      </Grid>
    </>
  );
}
